import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import translationEN from '../locales/en/translation.json';
import translationKO from '../locales/ko/translation.json';
import LanguageDetector from 'i18next-browser-languagedetector';
import { getItem, LocalLanguage, setItem } from '../utils/localStorage';

const resources = {
  en: {
    translation: translationEN,
  },
  ko: {
    translation: translationKO,
  },
};

function storedLanguage(): 'en' | 'ko' | null {
  const stored = getItem(LocalLanguage);
  const code = typeof stored === 'string' ? stored.split('-')[0] : null;
  if (code === 'en' || code === 'ko') return code;
  return null;
}

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    lng: storedLanguage() ?? undefined,
    fallbackLng: 'en',
    supportedLngs: ['en', 'ko'],
    load: 'languageOnly',
    interpolation: {
      escapeValue: false,
    },
    detection: {
      order: ['navigator', 'htmlTag'],
      caches: [],
    },
  });

setItem(LocalLanguage, i18n.resolvedLanguage === 'ko' ? 'ko' : 'en');

export default i18n;
